import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './TourPage.css';

const SLIDES = [
  {
    headline: 'One Stop for All Transactions',
    body: 'Manage every real estate transaction end-to-end — offers, documents, milestones, and more — all in one place.',
    icon: (
      <svg width="72" height="72" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
        <polyline points="9 22 9 12 15 12 15 22" />
      </svg>
    ),
  },
  {
    headline: 'Stay Ahead of Every Deadline',
    body: 'Automated milestone tracking and smart reminders keep your transactions on schedule — never miss a critical date.',
    icon: (
      <svg width="72" height="72" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
        <circle cx="12" cy="16" r="2" fill="currentColor" stroke="none" />
      </svg>
    ),
  },
  {
    headline: 'Work Smarter with Everyone Involved',
    body: 'Agents, buyers, sellers, and coordinators collaborate in real time — with role-based access keeping each party in their lane.',
    icon: (
      <svg width="72" height="72" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
  },
];

const TourPage = () => {
  const navigate = useNavigate();
  const [current, setCurrent] = useState(0);

  const markSeen = () => localStorage.setItem('hasSeenTour', 'true');

  const handleSkip = () => { markSeen(); navigate('/login'); };
  const handleGetStarted = () => { markSeen(); navigate('/register'); };

  const handleNext = () => {
    if (current < SLIDES.length - 1) {
      setCurrent(current + 1);
    } else {
      handleGetStarted();
    }
  };

  const handlePrev = () => {
    if (current > 0) setCurrent(current - 1);
  };

  const slide = SLIDES[current];
  const isLast = current === SLIDES.length - 1;

  return (
    <div className="tour-page">
      <button className="tour-skip" onClick={handleSkip}>
        Skip
      </button>

      <div className="tour-content">
        <div className="tour-icon">{slide.icon}</div>
        <h1 className="tour-headline">{slide.headline}</h1>
        <p className="tour-body">{slide.body}</p>
      </div>

      <div className="tour-dots">
        {SLIDES.map((_, i) => (
          <button
            key={i}
            className={`tour-dot ${i === current ? 'tour-dot--active' : ''}`}
            onClick={() => setCurrent(i)}
            aria-label={`Go to slide ${i + 1}`}
          />
        ))}
      </div>

      <div className="tour-actions">
        {current > 0 && (
          <button className="tour-btn-secondary" onClick={handlePrev}>
            Back
          </button>
        )}
        <button className="tour-btn-primary" onClick={handleNext}>
          {isLast ? 'Get Started' : 'Next'}
        </button>
      </div>

      <button className="tour-login-link" onClick={() => { markSeen(); navigate('/login'); }}>
        Already have an account? <span>Log in</span>
      </button>
    </div>
  );
};

export default TourPage;
